import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { useLayoutV3State } from 'hooks/useLayoutV3State'
// import React from 'react'
import styled from 'styled-components'
import InfiniteWinning from './InfiniteWinning/InfiniteWinning'
// import ShortTermPrediction from './ShortTermPrediction/ShortTermPrediction'
// import YoloDays from './YoloDays/YoloDays'
import { config } from 'config/index'
import { SKINS } from 'constants/skins'
import { WalletInfo } from './Wallet'
import { YoloLanding } from 'components/Organisms/PageContent/Landing/YoloLanding'
import { WsbLanding } from 'components/Organisms/PageContent/Landing/WsbLanding'
import { RestrictPage } from 'components/Organisms/PageContent/Restrict'
import { Referrals } from './Referrals'
import { YoloToken } from 'components/Organisms/MainGames/YoloToken'
import { PrivatePresale } from 'components/Organisms/MainGames/PrivatePresale'
import { BustedPlay } from 'components/Organisms/MainGames/Busted/BustedPlay'
import { DAppProvider } from '@usedapp/core'
import { dappConfig } from 'config/dappConfig'
import { Achievement } from 'components/Organisms/PageContent/Achievement'
import { PublicPresale } from 'components/Organisms/PageContent/PublicPresale'

const { APP_SKIN_VERSION } = config

const landingBySkin = {
  [SKINS.WSB]: <WsbLanding />,
}[APP_SKIN_VERSION] || <YoloLanding />

export const Gameplay = () => {
  const { currentGame } = useLayoutV3State()
  const isLanding = currentGame === CONTENT_TYPES.LANDING
  return (
    <GameCenterWrapper isLanding={isLanding}>
      <ContentSwitcherByState
        noWrapper
        activeState={currentGame}
        stateObject={{
          [CONTENT_TYPES.LANDING]: landingBySkin,
          [CONTENT_TYPES.RESTRICTED]: <RestrictPage />,
          [CONTENT_TYPES.WALLET]: <WalletInfo />,
          [CONTENT_TYPES.REFERRALS]: <Referrals />,
          [CONTENT_TYPES.G_3MIN]: <YoloLanding />,
          // [CONTENT_TYPES.G_3MIN]: <ShortTermPrediction />,
          [CONTENT_TYPES.G_24HR]: <YoloLanding />,
          // [CONTENT_TYPES.G_24HR]: <YoloDays />,
          [CONTENT_TYPES.LVG_AI_INDEXES]: <InfiniteWinning />,
          [CONTENT_TYPES.LVG_INDEXES]: <InfiniteWinning />,
          // [CONTENT_TYPES.LVG_STOCKS]: <InfiniteWinning />,
          [CONTENT_TYPES.LVG_CRYPTO]: <InfiniteWinning />,
          [CONTENT_TYPES.YOLO_TOKEN]: <YoloToken />,
          [CONTENT_TYPES.ACHIEVEMENT]: <Achievement />,
          [CONTENT_TYPES.PRIVATE_PRESALE]: (
            <DAppProvider config={dappConfig}>
              <PrivatePresale />
            </DAppProvider>
          ),
          [CONTENT_TYPES.PUBLIC_PRESALE]: (
            <DAppProvider config={dappConfig}>
              <PublicPresale />
            </DAppProvider>
          ),
          // [CONTENT_TYPES.G_BUSTED]: <BustedPlay />,
        }}
      ></ContentSwitcherByState>
    </GameCenterWrapper>
  )
}

const GameCenterWrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 0;
  z-index: 0;

  @media (max-width: 1600px) {
    ${(props) => (props.isLanding ? 'padding: 0 0 0 90px;' : 'padding: 0px 50px 0px 90px;')}
  }

  @media (max-width: 1600px) {
    ${(props) => (props.isLanding ? 'padding: 0 0 0 90px;' : '')}
  }

  @media (max-width: 800px) {
    ${(props) => (props.isLanding ? 'padding: 0 0 0 30px;' : 'padding: 0px 30px 0px 30px;')}
  }

  @media (max-width: 800px) {
    ${(props) => (props.isLanding ? 'padding: 0 0 0 30px;' : '')}
  }
`
